import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  redirectNotification = '';
  message = 'Checking auth status';

  constructor(
   private auth: AuthService,
   private router: Router
  ) { }

  async ngOnInit() {
    let user = this.auth.userPool.getCurrentUser();
    if (user) {
      this.message = 'Logging out.';
      this.auth.logout();
    } else {
      this.message = 'Logged out.'
      // this.redirectNotification = 'You will now be redirected to the login page.'
      setTimeout(() => {window.location.href = 'https://kempercorporation.sharepoint.com/sites/mykemper'}, 2000);
    }
  }

}
